@if (screen === 'form' || (message && (productGroup || screen === 'sms'))) {
  <div
    [id]="wrapperId()"
    [ngClass]="{
      phone: true,
      stretch: stretch,
      'phone--expanded': previewMode === 'expanded',
      'phone--large': large,
      'response-messages': screen === 'form' && showPdfMarkup === false,
      'response-messages--form': screen === 'form' && showPdfMarkup === false
    }"
    >
    <div class="bazzel">
      <div class="screen" [class.stretch]="stretch">
        <div class="card-phone" [class.stretch]="stretch">
          <!-- render Wire header -->
          @if (
            (screen === 'wire' || screen === 'feed' || screen === 'form') &&
            !newFeed.enabled
            ) {
            <div
              class="card-phone-header"
              [ngStyle]="{ 'background-color': headerColor }"
              (click)="viewMenu = !viewMenu"
              >
              @if (!productGroup?.hide_hamburger) {
                <i
                  class="card-phone-menu fa fa-bars"
                ></i>
              }
              <h3 class="card-phone-title">{{ headerTitle }}</h3>
            </div>
          }
          <!-- Render Feed header -->
          @if (
            (screen === 'wire' || screen === 'feed' || screen === 'form') &&
            newFeed.enabled
            ) {
            <product-group-preview-react
              [messageId]="messageId"
              [logoUrl]="logoUrl"
              [color]="headerColor"
              [showProductGroup]="!productGroup?.hide_pg_wire_display_name"
              [productGroupName]="productGroup?.name || ''"
              [bannerUrl]="productGroup?.branding?.banner_s3_url || ''"
              [productGroupDescription]="productGroup?.description || ''"
              [showBanner]="productGroup?.show_banner"
              [showLogo]="productGroup?.show_logo"
              [showTitleBar]="productGroup?.show_title_bar"
              [hideHamburger]="productGroup?.hide_hamburger"
            ></product-group-preview-react>
          }
          <!-- Render powerUp preview -->
          @if (screen === 'form') {
            <div>
              <h3 class="response-messages__form-label">{{ formLabel }}</h3>
              <img class="full-width" [src]="powerUpPlaceholderUrl" />
            </div>
          }
          @if (screen === 'wire' && !newFeed.enabled) {
            <wire-preview
              [branding]="message.wire.branding"
              [wire]="message.wire"
              [productGroup]="productGroup"
              [hasIWCU]="hasIWCU"
              [showPdfMarkup]="showPdfMarkup"
              [isJourneyPreview]="isJourneyPreview"
              (toggleCollapsible)="toggleCollapsible.emit()"
            ></wire-preview>
          }
          @if (screen === 'wire' && newFeed.enabled) {
            <wire-preview-react
              [message]="message"
              [components]="components"
              [brandingColor]="headerColor"
              [disclaimerConfig]="disclaimerConfig"
              [productGroup]="productGroup"
              [previewMode]="previewMode"
              [language]="language"
              [showFeedViewDisclaimer]="showFeedViewDisclaimer"
            ></wire-preview-react>
          }
          @if (screen === 'sms') {
            <bubble [text]="message.sms.text"></bubble>
          }
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="header">
      <div class="sensor-1"></div>
      <div class="sensor-2"></div>
      <div class="sensor-3"></div>
    </div>
    <div class="volume-button"></div>
    <div class="power-button"></div>
  </div>
  <!-- This recursively generates an additional preview for all "branch" messages (messageResponse types) and any branches-of-branches -->
  @if (recursive && journeyContent) {
    <div>
      @for (responseMsg of getAllResponseMessages(); track responseMsg; let i = $index) {
        <div
          id="response-messages-{{ message.name }}"
          class="response-messages"
          >
          <phone
            [message]="responseMsg"
            [screen]="screen"
            [recursive]="true"
            [stretch]="stretch"
            [preivewMode]="previewMode"
            [journeyContent]="journeyContent"
            [productGroup]="productGroup"
            [components]="components"
            id="response-msg-{{ responseMsg.name }}"
            >
          </phone>
        </div>
      }
    </div>
  }
}
